import script from "./DocumentUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentUpload.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentUpload.vue?vue&type=style&index=0&id=0bf31e51&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bf31e51"]])

export default __exports__